class KCVS.Views.ProjectPartnerFormView extends Backbone.View

  initialize: ->
    @events = {}
    _.each ["ir", "ed", "ter"], (type) =>
      @events["change #project_partner_#{type}_refund_intensity"] = -> @calculateFinancing(type)
      @events["change .#{type}_cost"] = -> @calculateFinancing(type)
      @delegateEvents()

  calculateFinancing: (type) ->
    intensity = Helper.inputToFloat($("#project_partner_#{type}_refund_intensity").val())
    cost = _.reduce($(".#{type}_cost"), ((memo, el) -> Helper.inputToFloat(el.value) + memo), 0)
    financing = (intensity / 100.0 * cost).toFixed(2)
    $("#project_partner_#{type}_financing").val(financing)


